import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css'
})
export class PaginationComponent implements OnChanges {
  private translate = inject(TranslateService);

  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Input() lastPage: boolean = false;
  @Input() firstPage: boolean = false;
  @Input() compact: boolean = false;
  @Input() showPageInfo: boolean = true;
  @Output() pageChange = new EventEmitter<number>();

  visiblePages: (number | string)[] = [];

  get pageLabel(): string {
    const key = 'PAGINATION.PAGE';
    const val = this.translate.instant(key);
    return val && val !== key ? val : 'Page';
  }

  get ofLabel(): string {
    const key = 'PAGINATION.OF';
    const val = this.translate.instant(key);
    return val && val !== key ? val : (this.translate.currentLang === 'en' ? 'of' : 'sur');
  }

  get previousLabel(): string {
    const key = 'PAGINATION.PREVIOUS';
    const val = this.translate.instant(key);
    return val && val !== key ? val : (this.translate.currentLang === 'en' ? 'Previous' : 'Précédent');
  }

  get nextLabel(): string {
    const key = 'PAGINATION.NEXT';
    const val = this.translate.instant(key);
    return val && val !== key ? val : (this.translate.currentLang === 'en' ? 'Next' : 'Suivant');
  }

  ngOnChanges(): void {
    this.updateVisiblePages();
  }

  updateVisiblePages(): void {
    const pages: (number | string)[] = [];
    if (!this.totalPages || this.totalPages <= 0) {
      this.visiblePages = [];
      return;
    }
    if (this.totalPages <= 7) {
      for (let i = 1; i <= this.totalPages; i++) pages.push(i);
    } else {
      if (this.currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, '...', this.totalPages);
      } else if (this.currentPage >= this.totalPages - 3) {
        pages.push(1, '...', this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages);
      } else {
        pages.push(1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages);
      }
    }

    this.visiblePages = pages;
  }

  goToPage(page: number | string): void {
    if (typeof page === 'number' && page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }
}
